var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relevancy-tab"},_vm._l((_vm.data),function(item,i){return _c('div',{key:i},[_c('p',[_vm._v(_vm._s(item.name))]),_c('i',{staticClass:"iconfont icon-shanchu",on:{"click":function($event){_vm.delTab(item)}}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }